import { useColorModeValue } from '@chakra-ui/color-mode';
import {
  AlertStatus,
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
} from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { requestServerApi, serverApi } from '../../api/api';
import { TLessonLearner } from '../../api/server';
import '../../assets/styles/index.scss';
import { getLessonLearnerStatusBadge } from '../../components/BadgeStatus';
import CustomPagination from '../../components/CustomPagination';
import { FEED_BACK_STATUS } from '../../configs';
import { useAppSelector } from '../../hooks';
import useAppToast from '../../hooks/useAppToast/useAppToast';
import useErrorPage from '../../hooks/useErrorPage/useErrorPage';
import useInterval from '../../hooks/useInterval/useInterval';
import useLessonByIdAndCompanyId from '../../hooks/useLesson/useLessonByIdAndCompanyId';
import { getIsNotAttendees, getIsRoomEntryEnabled } from '../../libs/lesson/lesson';
import FeedbackEditModal from '../feedback/Modal/FeedbackEditModal/FeedbackEditModal';
import FeedbackModal from '../feedback/Modal/FeedbackModal/FeedbackModal';
import NoteEditModal from '../lesson_notes/NoteEditModal/NoteEditModal';
import NoteModal from '../lesson_notes/NoteModal/NoteModal';
import './index.scss';
import LessonInfo from './LessonInfo';
import AgreementLessonModal from './Modal/AgreementLessonModal/AgreementLessonModal';
import BulkFeedbackUpdateModal from './Modal/BulkFeedbackUpdateModal/BulkFeedbackUpdateModal';
import FeedbackAlreadyExistModal from './Modal/FeedbackAlreadyExistModal/FeedbackAlreadyExistModal';
import ThemeEditModal from './Modal/ThemeEditModal/ThemeEditModal';
import ThemeModal from './Modal/ThemeModal/ThemeModal';

export type ModalType =
  | ''
  | 'approvalLessonModal'
  | 'bulkFeedbackUpdateModal'
  | 'feedbackAlreadyExistModal'
  | 'themeModal'
  | 'themeEditModal'
  | 'feedbackEditModal'
  | 'feedbackModal'
  | 'noteModal'
  | 'noteEditModal';
function Index() {
  const params = useParams<{ companyId: string; lessonId: string }>();
  const lesson_id: string = params.lessonId;
  const companyId = params.companyId;

  const { displayToast } = useAppToast();
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit: number = 4;
  const [refreshFlg, setRefreshFlg] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [disable, setDisable] = useState<boolean>(true);
  const [lessonNotFinished, setLessonNotFinished] = useState<boolean>(false);
  const history = useHistory();
  const { lesson } = useLessonByIdAndCompanyId(lesson_id, companyId, refreshFlg);
  const { apiErrorHandler } = useErrorPage();
  const userState = useAppSelector((state) => state.user);
  const teacherId = userState.user?.['cognito:username'] as string;

  const [isNoAttendees, setIsNoAttendees] = useState(false);
  useEffect(() => {
    setIsNoAttendees(getIsNotAttendees(lesson));
  }, [lesson]);
  // 1秒ごとに確認
  useInterval(() => {
    if (lesson === null) {
      goBackTop();
      return;
    }
    checkLessonEnter();
  }, 1000 * 1);

  const goBackTop = () => history.push('/top');
  const checkLessonEnter = useCallback(() => {
    setDisable(
      !getIsRoomEntryEnabled(
        lesson?.start_datetime,
        lesson?.end_datetime,
        lesson?.approval_flg,
        lesson?.cancel_flg,
      ),
    );
  }, [lesson]);

  useEffect(() => {
    if (lesson === null) {
      goBackTop();
      return;
    }

    setTotalPages(
      Math.ceil(
        lesson?.t_lesson_learner?.length >= limit ? lesson?.t_lesson_learner?.length / limit : 1,
      ),
    );
    hasLessonFinished(lesson?.end_datetime);
    checkLessonEnter();
  }, [lesson, disable]);

  const handlePageChange = (targetPage: number) => {
    setCurrentPage(targetPage);
  };

  useEffect(() => {
    setRefreshFlg(false);
  }, [refreshFlg == true]);

  // Modal切り分け用
  const [selectedModal, setSelectedModal] = useState<ModalType>('');
  const [selectedItem, setSelectedItem] = useState<any>('');

  // モーダルを開く
  const onOpenModal = (name: ModalType, item: any) => {
    if (name === 'bulkFeedbackUpdateModal') {
      setSelectedItem({ ...item, feed_back: '' });
    } else {
      setSelectedItem(item);
    }
    setSelectedModal(name);
  };

  // モーダルを閉じる
  const onCloseModal = () => {
    setSelectedModal('');
    setConfirming(false);
  };

  const onCheckFeedBackExist = () => {
    setConfirming(true);
    const apiResponse = requestServerApi<any>(() =>
      serverApi.organizationsControllerGetLessonFeedbackList(
        '',
        0,
        '',
        lesson.lesson_id,
        '',
        '',
        '',
        0,
        0,
        0,
      ),
    );
    apiResponse.then((result) => {
      if (result?.data?.data?.length > 0) {
        let apiData = result.data.data[0][0];
        let feedbackExists = apiData.some((feedbackList: any) => feedbackList.feed_back);
        if (feedbackExists) {
          onOpenModal('feedbackAlreadyExistModal', lesson);
        } else {
          onOpenModal('bulkFeedbackUpdateModal', lesson);
        }
      }
    });
  };

  const onClickLearnerDetail = (learner_id: string) => {
    // history.push(`/${lesson_id}/learners/${learner_id}`, { companyId });
    window.open(`/lesson/${companyId}/${lesson_id}/learners/${learner_id}`);
  };

  //disable feedback button if lesson has not finished yet
  const hasLessonFinished = (end_datetime: Date) => {
    const current_time: Date = new Date();
    const lesson_end_time: Date = new Date(end_datetime);
    if (current_time <= lesson_end_time) {
      setLessonNotFinished(true);
    } else {
      setLessonNotFinished(false);
    }
  };

  //update the lesson status
  const updateLessonStatus = async (e: any) => {
    var status = e.status;
    const apiResponse = requestServerApi<any>(() =>
      serverApi
        .organizationsControllerUpdateLessonStatusTeacher(lesson?.company_id, lesson_id, status)
        .catch((e) =>
          apiErrorHandler(e, {
            componentName: 'lesson',
            functionName: serverApi.organizationsControllerUpdateLessonStatusTeacher.name,
          }),
        ),
    );
    apiResponse.then((data) => {
      if (data?.data.message) {
        reactToUpdation(
          data.data.message,
          status === 'approved' ? 'レッスン承認' : 'レッスン予約キャンセル',
        );
      }
      setRefreshFlg(true);
    });
  };

  //　更新後の処理
  const reactToUpdation = (msg: string, toastTitle: string) => {
    var toastDescription: string =
      msg === 'NO_ERROR' ? `${toastTitle}に成功しました。` : `${toastTitle}に失敗しました。`;
    var toastStatus: AlertStatus = msg === 'NO_ERROR' ? 'success' : 'error';
    setTimeout(() => {
      onCloseModal();
      displayToast(toastTitle, toastDescription, toastStatus);
    }, 1000);
  };

  const getTeacherData = async () => {
    const result = await requestServerApi<any>(() =>
      serverApi.organizationsControllerGetTeacherByTeacherId(teacherId).catch((e) =>
        apiErrorHandler(e, {
          componentName: 'preview',
          functionName: serverApi.organizationsControllerGetTeacherByTeacherId.name,
        }),
      ),
    );
    if (result?.data?.code === 200) {
      const nickName = result?.data?.data[0]?.nick_name;
      return nickName;
    } else {
      return '';
    }
  };
  return (
    <>
      {'themeModal' === selectedModal && (
        <ThemeModal onOpenModal={onOpenModal} onCloseModal={onCloseModal} lesson={lesson} />
      )}
      {'themeEditModal' === selectedModal && (
        <ThemeEditModal
          onCloseModal={onCloseModal}
          lesson={lesson}
          onUpdateSuccess={(result: any) => {
            reactToUpdation(result.data.message, 'テーマの更新');
            setRefreshFlg(true);
          }}
        />
      )}
      {'feedbackModal' === selectedModal && (
        <FeedbackModal
          onClose={onCloseModal}
          onOpenfeedbackEditModal={() => setSelectedModal('feedbackEditModal')}
          feed_back={selectedItem?.feed_back}
          admin_comment={selectedItem?.admin_comment}
          start_datetime={lesson?.start_datetime}
          end_datetime={lesson?.end_datetime}
          learner_name={selectedItem?.m_learner?.nick_name}
          participation_status={selectedItem?.participation_status}
          learner_id={selectedItem?.learner_id}
          company_id={selectedItem?.company_id}
          t_lesson_learner_documents={selectedItem?.t_lesson_learner_documents}
          payment_id={lesson?.payment_id}
        />
      )}
      {'feedbackEditModal' === selectedModal && (
        <FeedbackEditModal
          onClose={onCloseModal}
          setRefreshFlg={setRefreshFlg}
          feed_back={selectedItem?.feed_back}
          admin_comment={selectedItem?.admin_comment}
          start_datetime={lesson?.start_datetime}
          end_datetime={lesson?.end_datetime}
          company_id={lesson?.company_id}
          lesson_id={lesson?.lesson_id}
          learner_id={selectedItem?.learner_id}
          learner_name={selectedItem?.m_learner?.nick_name}
          participation_status={selectedItem?.participation_status}
          t_lesson_learner_documents={selectedItem?.t_lesson_learner_documents}
          payment_id={lesson?.payment_id}
        />
      )}
      {'feedbackAlreadyExistModal' === selectedModal && (
        <FeedbackAlreadyExistModal
          lesson={lesson}
          onClose={onCloseModal}
          onOpenModal={onOpenModal}
        />
      )}
      {'bulkFeedbackUpdateModal' === selectedModal && (
        <BulkFeedbackUpdateModal
          onClose={onCloseModal}
          selectedItem={selectedItem}
          onUpdateSuccess={(msg: string) => {
            reactToUpdation(msg, 'フィードバック更新');
            setRefreshFlg(true);
          }}
          learnerIdArray={lesson?.t_lesson_learner?.map((item: TLessonLearner) => item.learner_id) || []}
        />
      )}
      {'noteModal' === selectedModal && (
        <NoteModal
          onClose={onCloseModal}
          onOpenNoteEditModal={() => setSelectedModal('noteEditModal')}
          start_datetime={selectedItem?.start_datetime}
          end_datetime={selectedItem?.end_datetime}
          note={selectedItem?.note}
        />
      )}
      {'noteEditModal' === selectedModal && (
        <NoteEditModal
          onClose={onCloseModal}
          setRefreshFlg={setRefreshFlg}
          start_datetime={selectedItem?.start_datetime}
          end_datetime={selectedItem?.end_datetime}
          note={selectedItem?.note}
          company_id={selectedItem?.company_id}
          lesson_id={selectedItem?.lesson_id}
        />
      )}
      {'approvalLessonModal' === selectedModal && (
        <AgreementLessonModal onClose={onCloseModal} updateLessonStatus={updateLessonStatus} />
      )}
      {/* 画面描画エリア */}
      <Flex justifyContent="space-between" alignItems="center">
        <Heading mt={5}>レッスン詳細</Heading>
      </Flex>
      <LessonInfo
        lesson={lesson}
        onOpenModal={onOpenModal}
        lessonNotFinished={lessonNotFinished}
        onCheckFeedBackExist={onCheckFeedBackExist}
        disable={disable}
        isNoAttendees={isNoAttendees}
      />
      <Flex alignItems={'flex-end'} justifyContent={'space-between'}>
        <Heading size="lg" mt={8}>
          参加学習者一覧
        </Heading>
        <Text>{`総件数: ${lesson?.t_lesson_learner?.length}件`}</Text>
      </Flex>

      <Stack
        px={'10'}
        mb={'10'}
        pb={'5'}
        border={'1px solid #ddd'}
        borderColor={useColorModeValue('#ddd', '#ddd')}
        rounded={'md'}
      >
        <Box>
          <Table variant="simple" height="auto">
            <Thead className="Lesson-TableHead">
              <Tr>
                <Th>出欠席</Th>
                <Th>フルネーム</Th>
                <Th>フィードバック</Th>
                <Th>操作</Th>
              </Tr>
            </Thead>
            <Tbody className="Lesson-TableBody">
              {lesson?.t_lesson_learner?.map((learner: TLessonLearner, idx: number) => (
                <Tr key={idx}>
                  <Td textAlign={'center'}>
                    {getLessonLearnerStatusBadge(learner)}
                    <br />
                    {learner?.cancel_reason ? `(${learner?.cancel_reason})` : ''}
                  </Td>
                  <Td whiteSpace="nowrap">{learner?.m_learner?.full_name}</Td>
                  <Td>
                    <Flex justifyContent={'center'} alignItems={'center'} gap={2}>
                      <Badge
                        colorScheme={
                          learner?.feed_back === '' || learner?.feed_back === null ? 'red' : 'green'
                        }
                        style={{
                          lineHeight: '1.75rem',
                          width: '6rem',
                          textAlign: 'center',
                        }}
                        fontSize={'md'}
                      >
                        {learner?.feed_back ? FEED_BACK_STATUS.COMPLETED : FEED_BACK_STATUS.BLANK}
                      </Badge>

                      <Button
                        colorScheme="linkedin"
                        size="sm"
                        onClick={() => onOpenModal('feedbackModal', learner)}
                        disabled={!lesson || lessonNotFinished || lesson?.delete_flg}
                      >
                        フィードバック登録
                      </Button>
                    </Flex>
                  </Td>
                  <Td>
                    <Button
                      colorScheme="linkedin"
                      size="sm"
                      onClick={() => onClickLearnerDetail(learner.learner_id)}
                    >
                      詳細
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        {lesson?.t_lesson_learner?.length > 0 && (
          <CustomPagination
            page={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </Stack>
    </>
  );
}

export default Index;
